// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"138":"profile","609":"faq","619":"pay"}[chunkId] + "-legacy." + {"138":"4cf5bd36","609":"ea26acdb","619":"6fd496c3"}[chunkId] + ".js";
};